import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTooltip } from '@angular/material/tooltip';
import { Router } from '@angular/router';
import { BpAddressService } from 'src/app/services/bp-address.service';
import { LocationService } from 'src/app/services/ecommerce/location.service';
import { LocationMapComponent } from '../location-map/location-map.component';
import { LocationOpenMapComponent } from '../location-open-map/location-open-map.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'ms-add-address',
  templateUrl: './add-address.component.html',
  styleUrl: './add-address.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class AddAddressComponent implements OnInit, OnDestroy {
  @ViewChild('tooltip', { static: true }) tooltip?: MatTooltip;
  formData: FormGroup;
  id = null;
  loadSave: boolean = false;

  //Lista pais departamento, distrito ciudad
  listCountry: any[] = [];
  listFilterCountry: any[] = [];
  loadCountry = false;
  searchCountry = '';

  listDepartment: any[] = [];
  listFilterDepartment: any[] = [];
  loadDepartment = false;
  searchDepartment = '';

  listCity: any[] = [];
  listFilterCity: any[] = [];
  loadCity = false;
  searchCity = '';

  listDistrict: any[] = [];
  listFilterDistrict: any[] = [];
  loadDistrict = false;
  searchDistrict = '';

  //VALOR INDEFINIDO
  // isPrincipal;

  constructor(
    public router: Router,

    private addressService: BpAddressService,
    private locationService: LocationService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private fb: FormBuilder,
    private cdRef: ChangeDetectorRef,
    private translate: TranslateService,
    public dialogRef: MatDialogRef<AddAddressComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.formData = this.fb.group({
      name: [null, [Validators.required]], // utilizare Name para definir mi Direccion Principal
      country: [null, [Validators.required]],
      location_one: [null, [Validators.required]],
      location_two: [null, [Validators.required]],
      location_three: [null],
      address: ['', [Validators.required, Validators.maxLength(250)]],
      reference: ['', [Validators.required, Validators.maxLength(250)]],
      latitude: [12.134497, [Validators.required]],
      longitude: [-86.269994, [Validators.required]],
    });

    // 12.134497, -86.269994
  }
  ngOnInit() {
    console.log(this.data);
    this.initForm();
  }
  initForm() {
    if (this.data == null) {
      this.id = null;
      this.getCountries();
    } else {
      this.id = this.data.id; // si es 0 o '0' Significa que es el pricipal y l oretorno mas no lo guardo
      this.formData.setValue({
        name: this.data.name,
        country: this.data.country_code,
        location_one: this.data.location_one_code,
        location_two: this.data.location_two_code,
        location_three: this.data.location_three_code,
        address: this.data.address,
        reference: this.data.reference,
        latitude: this.data.latitude ? this.data.latitude : 12.010758636845642,
        longitude: this.data.longitude ? this.data.longitude : -86.21626793808812
        //active: this.data.active]
      });
      if (this.data.country_code != null) {
        this.getDepartments();
      } else {
        this.getCountries();
      }
      if (this.data.location_one_code != null) {
        this.getCitys();
      }
      if (this.data.location_two_code != null) {
        this.getDistricts();
      }
    }
  }
  // GUARDAR O ACTUALIZAR
  onSubmit() {
    if (
      this.formData.get('name')?.invalid ||
      this.formData.get('country')?.invalid ||
      this.formData.get('location_one')?.invalid ||
      this.formData.get('location_two')?.invalid ||
      this.formData.get('address')?.invalid
    ) {
      return;
    }

    if (
      this.formData.get('latitude')?.invalid ||
      this.formData.get('longitude')?.invalid ||
      this.formData.get('longitude')?.value == '0.0' ||
      this.formData.get('longitude')?.value == ''
    ) {
      this.tooltip?.show();
      return;
    }
    if (this.formData.get('reference')?.invalid) {
      return;
    }

    if (this.id == 0) {
      let audRe = Object.assign({}, this.formData.value);
      audRe.id = this.id;
      this.dialogRef.close(audRe);
      return;
    }

    this.loadSave = true;
    if (this.id == null) {
      this.addressService.setAddresByBp(this.formData.value).subscribe((res: any) => {
        console.log(res)
        this.formData.reset();
        this.loadSave = false
        this.translate
        .get('TRANSLATE.REGISTER_SUCCESSFUL')
        .subscribe((translatedMessage) => {
          this.snackBar.open(translatedMessage, '×', {
            panelClass: 'success',
            verticalPosition: 'top',
            duration: 3000,
          });
        });
        this.dialogRef.close(res)
      }, error => {
        this.loadSave = false
        this.snackBar.open(error.error.message, '×', { panelClass: 'error', verticalPosition: 'top', duration: 3000 });
      })
    } else {
      this.addressService
        .updateAddresByBp(this.id, this.formData.value)
        .subscribe(
          (res: any) => {
            console.log(res);
            this.formData.reset();

            this.loadSave = false;
            this.translate
              .get('TRANSLATE.EDITION_SUCCESSFUL')
              .subscribe((translatedMessage) => {
                this.snackBar.open(translatedMessage, '×', {
                  panelClass: 'success',
                  verticalPosition: 'top',
                  duration: 3000,
                });
              });

            let audRe = Object.assign({}, this.formData.value);
            audRe.id = this.id;
            this.dialogRef.close(audRe);
          },
          (error) => {
            this.loadSave = false;
            this.snackBar.open(error.error.message, '×', {
              panelClass: 'error',
              verticalPosition: 'top',
              duration: 3000,
            });
          }
        );
    }
  }
  openMap() {
    //analizar pais y ciudad

    let data = {
      country:
        this.formData.get('country')?.value == null ||
        this.formData.get('country')?.value == ''
          ? null
          : this.getNameCountry(),
      dep:
        this.formData.get('location_one')?.value == null ||
        this.formData.get('location_one')?.value == ''
          ? null
          : this.getNameDepartment(),
      city:
        this.formData.get('location_two')?.value == null ||
        this.formData.get('location_two')?.value == ''
          ? null
          : this.getNameCity(),

      location_three:
        this.formData.get('location_three')?.value == null ||
        this.formData.get('location_three')?.value == ''
          ? null
          : this.getNameDistrict(),
      address: this.formData.value.address, // TODO: CONCATENAR EL PAIZ PARA REALIZAR LA BUSQUEDA
      latitude: this.formData.value.latitude,
      longitude: this.formData.value.longitude,
    };

    let addres = this.formData.get('address')?.value;

    const dialogRef = this.dialog.open(LocationOpenMapComponent, {
      width: '900px',
      panelClass: 'location-dialog',
      data: data,
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log('result del', result);
      if (result === undefined || result == 'Close') {
        console.log('close add-address');
      } else {
        console.log(result)
        this.formData.get('latitude')?.setValue(String(result.latitude))
        this.formData.get('longitude')?.setValue(String(result.longitude))
        this.formData.get('address')?.setValue(result.address)
      }
    });
  }
  // por pais

  getCountries() {
    this.loadCountry = true
    this.locationService.getCountryCb().subscribe((data: any) => {
      this.listCountry = data
      if ((this.id == null || this.id == 0)) { //this.listCountry.length == 1
        this.formData.get('country')?.setValue(this.listCountry[0].code)
        this.getDepartments()
      }
      this.listFilterCountry = this.listCountry.slice()
      this.loadCountry = false
    },
    error => {
      this.loadCountry = false
      //this.errorService.getErrorMessage(error)
    })
  }
  changueOptionsCountry(event: any) {
    console.log(event);
    if (!this.listCountry) {
      return;
    }
    let search = event;
    if (!search) {
      this.listFilterCountry = this.listCountry.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    this.listFilterCountry = this.listCountry.filter(
      (item) => item.name.toLowerCase().indexOf(search) > -1
    );
  }

  getDepartments() {
    this.loadDepartment = true
    this.locationService.getDepartmentComboCountry(this.formData.value.country).subscribe((data: any) => {
      this.listDepartment = data
      this.listFilterDepartment = this.listDepartment.slice()
      this.loadDepartment = false
    },
    error => {
      this.loadDepartment = false
      //this.errorService.getErrorMessage(error)
    })
  }
  changueOptionsDepartment(event: any) {
    console.log(event);
    if (!this.listDepartment) {
      return;
    }
    let search = event;
    if (!search) {
      this.listFilterDepartment = this.listDepartment.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    this.listFilterDepartment = this.listDepartment.filter(
      (item) => item.name.toLowerCase().indexOf(search) > -1
    );
  }

  // por departamento
  getCitys() {
    this.loadCity = true
    this.locationService.getCityComboDepartment(this.formData.value.location_one).subscribe((data: any) => {
      this.listCity = data
      this.listFilterCity = this.listCity.slice()
      this.loadCity = false
    },
    error => {
      this.loadCity = false
      //this.errorService.getErrorMessage(error)
    })
  }
  changueOptionsCity(event: any) {
    console.log(event);
    if (!this.listCity) {
      return;
    }
    let search = event;
    if (!search) {
      this.listFilterCity = this.listCity.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    this.listFilterCity = this.listCity.filter(
      (item) => item.name.toLowerCase().indexOf(search) > -1
    );
  }

  // por ciudad
  getDistricts() {
    this.loadDistrict = true
    this.locationService.getDistrictComboCity(this.formData.value.location_two).subscribe((data: any) => {
      this.listDistrict = data
      this.listFilterDistrict = this.listDistrict.slice()
      this.loadDistrict = false
    },
    error => {
      this.loadDistrict = false
      //this.errorService.getErrorMessage(error)
    })
  }

  changueOptionsDistrict(event:any) {
    console.log(event)
    if (!this.listDistrict) {
      return;
    }
    let search = event;
    if (!search) {
      this.listFilterDistrict = this.listDistrict.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    this.listFilterDistrict = this.listDistrict.filter(
      (item) => item.name.toLowerCase().indexOf(search) > -1
    );
  }

  onChangeCountry() {
    this.formData.get('location_one')?.setValue(null);
    this.listDepartment = [];
    this.listFilterDepartment = [];
    this.formData.get('location_two')?.setValue(null);
    this.listCity = [];
    this.listFilterCity = [];
    this.formData.get('location_three')?.setValue(null);
    this.listDistrict = [];
    this.listFilterDistrict = [];
    this.getDepartments();
  }

  onChangeDepartment() {
    this.formData.get('location_two')?.setValue(null);
    this.listCity = [];
    this.listFilterCity = [];
    this.formData.get('location_three')?.setValue(null);
    this.listDistrict = [];
    this.listFilterDistrict = [];
    this.getCitys();
  }

  onChangeCitys() {
    this.formData.get('location_three')?.setValue(null);
    this.listDistrict = [];
    this.listFilterDistrict = [];
    this.getDistricts();
  }

  getNameCountry() {
    let res = this.listCountry.find((element) => {
      return element.code === this.formData.value.country;
    });
    if (res) {
      return res.name;
    } else {
      return 'No asignado';
    }
  }

  getNameDepartment() {
    let res = this.listDepartment.find((element) => {
      return element.code === this.formData.value.location_one;
    });
    if (res) {
      return res.name;
    } else {
      return 'No asignado';
    }
  }
  getNameCity() {
    let res = this.listCity.find((element) => {
      return element.code === this.formData.value.location_two;
    });
    if (res) {
      return res.name;
    } else {
      return 'No asignado';
    }
  }
  getNameDistrict() {
    let res = this.listDistrict.find((element) => {
      return element.code === this.formData.value.location_three;
    });
    if (res) {
      return res.name;
    } else {
      return 'No asignado';
    }
  }
  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }

  ngOnDestroy() {}
}
